/**
 * This exists as a proxy between Formik and the Reactstrap inputs. The input props
 * aren't passed down correctly if you simply use the `compoenent={Input}` prop
 * like the documentation suggests.
 */

import React from 'react';
import { Input } from 'reactstrap';
import { Field } from 'formik';

const FormikInput = ({
  placeholder,
  disabled,
  value,
  children,
  invalid,
  onChange,
  onSelect,
  checked,
  step,
  className,
  defaultValue,
  type = 'text',
  component = Input,
  ...props
}) => {
  const Cmp = component;
  return (
    <Field
      render={({ field }) => (
        <Cmp
          className={className}
          value={value}
          step={step}
          checked={checked}
          onChange={onChange}
          onSelect={onSelect}
          type={type}
          {...field}
          disabled={disabled}
          defaultValue={defaultValue}
          placeholder={placeholder}
          children={children}
          invalid={invalid}
        />
      )}
      {...props}
    />
  );
};

export default FormikInput;



// WEBPACK FOOTER //
// ./src/components/formikInputField/formikInputField.jsx